import { Typography } from "@/components";
import NewspaperIcon from "@mui/icons-material/Newspaper";

interface EmptyBulletinProps {
	title?: string;
}

const EmptyBulletin = ({
	title = "Free bulletin board",
}: EmptyBulletinProps) => {
	return (
		<div className="h-full flex flex-col justify-center items-center gap-3">
			<div className="bg-white p-5 rounded-[3rem]">
				<NewspaperIcon className="!text-[5rem] !text-zinc-500" />
			</div>
			<Typography fontWeight={700} fontSize={16}>
				{title}
			</Typography>
		</div>
	);
};

export default EmptyBulletin;
